import { render, staticRenderFns } from "./EditComponents.vue?vue&type=template&id=4c1f7be9&scoped=true"
import script from "./EditComponents.vue?vue&type=script&lang=js"
export * from "./EditComponents.vue?vue&type=script&lang=js"
import style0 from "./EditComponents.vue?vue&type=style&index=0&id=4c1f7be9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f7be9",
  null
  
)

export default component.exports